import React from "react";
import { Box } from "@mui/material";

import penImage from "src/shared/assets/penAndLine/pen.png";
import penWithLineImage from "src/shared/assets/penAndLine/penWithLine.png";
import lineImage from "src/shared/assets/penAndLine/line.png";

export const AnimatedPen: React.FC = () => {
  return (
    <>
      <Box
        sx={{
          display: { md: "flex", xs: "none" },
          position: "absolute",
          left: 480,
          bottom: 0,
          height: 180,
          opacity: 0,
          animation:
            "firstPenAnimation 0.3s 1 linear 1s, secondPenAnimation 0.5s 1 linear 1.3s",
          zIndex: 2,
          backgroundColor: "transparent",
          animationFillMode: "forwards",

          "@keyframes firstPenAnimation": {
            "0%": { left: 480, bottom: 0, opacity: 1 },
            "10%": { left: 492, bottom: 4, opacity: 1 },
            "20%": { left: 504, bottom: 0, opacity: 1 },
            "30%": { left: 516, bottom: 4, opacity: 1 },
            "40%": { left: 528, bottom: 0, opacity: 1 },
            "50%": { left: 540, bottom: 4, opacity: 1 },
            "60%": { left: 552, bottom: 0, opacity: 1 },
            "70%": { left: 564, bottom: 4, opacity: 1 },
            "80%": { left: 576, bottom: 0, opacity: 1 },
            "90%": { left: 588, bottom: 4, opacity: 1 },
            "100%": { left: 600, bottom: 0, opacity: 1 },
          },

          "@keyframes secondPenAnimation": {
            "0%": { left: 612, bottom: 0, opacity: 1 },
            "12.5%": { left: 640, bottom: 8, opacity: 1 },
            "25%": { left: 660, bottom: 0, opacity: 1 },
            "37.5%": { left: 670, bottom: 4, opacity: 1 },
            "50%": { left: 690, bottom: 20, opacity: 1 },
            "62.5%": { left: 705, bottom: 8, opacity: 1 },
            "75%": { left: 718, bottom: 20, opacity: 1 },
            "87.5%": { left: 730, bottom: 2, opacity: 1 },
            "90%": { left: 735, bottom: 18, opacity: 1 },
            "100%": { left: 746, bottom: 21, opacity: 1 },
          },
        }}
      >
        <img src={penImage} height="100%" alt="Animated pen" />
      </Box>

      <Box
        sx={{
          display: { md: "flex", xs: "none" },
          position: "absolute",
          left: 620,
          bottom: 0,
          height: 200,
          opacity: 0,
          animation: "penWithLineAnimation 1s 1 linear 2.5s",
          animationFillMode: "forwards",
          zIndex: 1,
          backgroundColor: "transparent",

          "@keyframes penWithLineAnimation": {
            "0%": { opacity: 0 },
            "100%": { opacity: 1 },
          },
        }}
      >
        <img
          src={penWithLineImage}
          height="100%"
          alt="Animated pen with line"
        />
      </Box>

      <Box
        sx={{
          display: { md: "flex", xs: "none" },
          position: "absolute",
          left: 620,
          bottom: 0,
          height: 29,
          zIndex: 1,
          backgroundColor: "transparent",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            animation: "revealText 0.5s 1 linear 1.3s",
            animationFillMode: "forwards",
            zIndex: 1,
            backgroundColor: "background.default",

            "@keyframes revealLine": {
              "0%": { left: 0 },
              "50%": { left: "50%" },
              "100%": { left: "100%" },
            },
          }}
        />
        <img src={lineImage} height="100%" alt="Animated line" />
      </Box>
    </>
  );
};
